
import React, { FC, useEffect, useMemo, useState } from 'react';

export interface State {
  searchTerm: string;
}

const initialState = {
  searchTerm: '',
};

export const CompanyFinContext = React.createContext<State | any>(initialState);

CompanyFinContext.displayName = 'CompanyFinContext';

export const CompanyFinProvider: FC = (props) => {
  //const param = useParams();
  const [pldata, setPldata] = useState({});
  const [compratiodefault, setCompratiodefault] = useState({});
  const [compratiodefloading, setCompratiodefloading] = useState({});
  //console.log('context param', param)
  /* useEffect(() => {
    if (query?.text) {
      updateSearchTerm(query?.text as string);
    } else {
      updateSearchTerm('');
    }
  }); */

  const updatePlData = (PlData) => {
    console.log("SET PL data",PlData);
    setPldata(PlData)
  }
  
   const updatecompratioData = (comprationdata) => {
    console.log("SET Company default ratio",comprationdata);
    setCompratiodefault(comprationdata)
  }
  
  const value = useMemo(
    () => ({
      pldata,
      updatePlData,
      compratiodefault,
      setCompratiodefault,
      compratiodefloading, 
      setCompratiodefloading , 
    }),
    [pldata,compratiodefault]
  );

  return <CompanyFinContext.Provider value={value} {...props} />;
};

export const useCompanyFin = () => {
  const context = React.useContext(CompanyFinContext);
  if (context === undefined) {
    throw new Error(`useCompanyFin must be used within a CompanyFinProvider`);
  }
  return context;
};
